export default {
  "items": [
    {
      "name": "Buzz Aldrin",
      "company": "Apollo 11",
      "position": "Astronaut",
      "pic": "en-friends-01.jpg"
    },
    {
      "name": "Eric Schmidt",
      "company": "Google",
      "position": "Chairman",
      "pic": "en-friends-02.jpg"
    },
    {
      "name": "Steve Wozniak",
      "company": "Apple",
      "position": "Co-founder",
      "pic": "en-friends-03.jpg"
    },
    {
      "name": "Elon Musk",
      "company": "Tesla",
      "position": "Founder & CEO",
      "pic": "en-friends-04.jpg"
    },
    {
      "name": "Travis Kalanick",
      "company": "Uber",
      "position": "Founder & CEO",
      "pic": "en-friends-05.jpg"
    },
    {
      "name": "Ray Kurzweil",
      "company": "Singularity University",
      "position": "Founder",
      "pic": "en-friends-06.jpg"
    },
    {
      "name": "JB Straubel",
      "company": "Tesla",
      "position": "CTO",
      "pic": "en-friends-07.jpg"
    },
    {
      "name": "Harry Shum",
      "company": "Microsoft",
      "position": "Executive VP",
      "pic": "en-friends-08.jpg"
    },
    {
      "name": "Daniela Rus",
      "company": "MIT CSAIL",
      "position": "Director",
      "pic": "en-friends-09.jpg"
    },
    {
      "name": "Michael Landry",
      "company": "LIGO Handford",
      "position": "Head",
      "pic": "en-friends-10.jpg"
    },
    {
      "name": "Gang Chen",
      "company": "ME Department, MIT",
      "position": "Head",
      "pic": "en-friends-11.jpg"
    },
    {
      "name": "Xiaowen Hong",
      "company": "Microsoft",
      "position": "Global SVP",
      "pic": "en-friends-12.jpg"
    },
    {
      "name": "John Gaeta",
      "company": "Lucas Film | ILMxLAB",
      "position": "Executive Creative Director",
      "pic": "en-friends-13.jpg"
    },
    {
      "name": "Feifei Li",
      "company": "Google Cloud",
      "position": "Professor, Stanford | Chief Scientist",
      "pic": "en-friends-14.jpg"
    },
    {
      "name": "John Sculley",
      "company": "Apple",
      "position": "Ex-CEO",
      "pic": "en-friends-15.jpg"
    },
    {
      "name": "Michael I. Jordan",
      "company": "UC Berkeley AI Lab",
      "position": "Professor",
      "pic": "en-friends-16.jpg"
    },
    {
      "name": "Frank Azor",
      "company": "Alienware",
      "position": "GM",
      "pic": "en-friends-17.jpg"
    },
    {
      "name": "George O’Neal",
      "company": "Hyperloop One",
      "position": "SVP",
      "pic": "en-friends-18.jpg"
    },
    {
      "name": "Sangbae Kim",
      "company": "MIT Biomimetics Robotics Lab",
      "position": "Director",
      "pic": "en-friends-19.jpg"
    },
    {
      "name": "Andy Weir",
      "company": "The Martian",
      "position": "Author",
      "pic": "en-friends-20.jpg"
    },
    {
      "name": "Ryan Germick",
      "company": "Google Doodle",
      "position": "Head",
      "pic": "en-friends-21.jpg"
    },
    {
      "name": "Jon Wiley",
      "company": "Google Daydream",
      "position": "Director of Immersive Experience",
      "pic": "en-friends-22.jpg"
    },
    {
      "name": "John Markoff",
      "company": "New York Times",
      "position": "Senior Journalist",
      "pic": "en-friends-23.jpg"
    },
    {
      "name": "Edward Ross",
      "company": "Intel Edison",
      "position": "Global Product Director",
      "pic": "en-friends-24.jpg"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/mock/enfriends.js